// Guaranteed Fit 徽章与 YMM 选择器联动集成
// 此文件实现了当用户选择车辆信息后，自动更新Guaranteed Fit徽章的功能

/**
 * 初始化YMM选择器与Guaranteed Fit徽章的集成
 */
function initializeGuaranteedFitYMMIntegration() {
  // 等待DOM完全加载
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupIntegration);
  } else {
    setupIntegration();
  }
}

/**
 * 设置集成逻辑
 */
function setupIntegration() {
  // 获取YMM选择器元素
  const yearSelect = document.querySelector('select.ymm-select[name="properties[YmmYear]"]');
  const makeSelect = document.querySelector('select.ymm-select[name="properties[YmmMake]"]');
  const modelSelect = document.querySelector('select.ymm-select[name="properties[YmmModel]"]');
  
  // 检查是否存在所有必要的元素
  if (!yearSelect || !makeSelect || !modelSelect) {
    console.warn('Guaranteed Fit YMM Integration: 未找到YMM选择器元素');
    return;
  }
  
  // 存储默认的副标题文本
  storeDefaultSubtexts();
  
  // 添加事件监听器
  yearSelect.addEventListener('change', updateGuaranteedFitBadges);
  makeSelect.addEventListener('change', updateGuaranteedFitBadges);
  modelSelect.addEventListener('change', updateGuaranteedFitBadges);
  
  // 尝试扩展YMM选择器的updateModelOptions函数
  extendYMMSelector();
  
  // 初始加载时更新一次徽章
  updateGuaranteedFitBadges();
}

/**
 * 存储所有Guaranteed Fit徽章的默认副标题文本
 */
function storeDefaultSubtexts() {
  document.querySelectorAll('[id^="guaranteed-fit-"].guaranteed-fit-badge-wrapper').forEach(badgeWrapper => {
    const subtext = badgeWrapper.querySelector('.guaranteed-fit-badge__subtext');
    if (subtext) {
      // 存储默认副标题文本，用于重置
      badgeWrapper.dataset.defaultSubtext = subtext.textContent;
    }
  });
}

/**
 * 更新所有Guaranteed Fit徽章
 */
function updateGuaranteedFitBadges() {
  // 获取当前选择的车辆信息
  const year = document.querySelector('select.ymm-select[name="properties[YmmYear]"]')?.value;
  const make = document.querySelector('select.ymm-select[name="properties[YmmMake]"]')?.value;
  const model = document.querySelector('select.ymm-select[name="properties[YmmModel]"]')?.value;
  
  // 验证是否已选择完整的车辆信息
  const isVehicleSelected = year && year !== 'Year' && 
                           make && make !== 'Make' && 
                           model && model !== 'Model' && model !== 'No models found';
  
  // 更新所有徽章实例
  document.querySelectorAll('[id^="guaranteed-fit-"].guaranteed-fit-badge-wrapper').forEach(badgeWrapper => {
    const subtext = badgeWrapper.querySelector('.guaranteed-fit-badge__subtext');
    const badgeContainer = badgeWrapper.querySelector('.guaranteed-fit-badge');
    
    if (subtext && badgeContainer) {
      if (isVehicleSelected) {
        // 显示具体的车辆信息
        subtext.textContent = `${year} ${make} ${model}`;
        
        // 增强视觉反馈
        enhanceBadgeWithVisualFeedback(badgeWrapper, true);
        
        // 添加车辆选择完成的动画效果
        badgeContainer.classList.add('guaranteed-fit-badge--selected');
        setTimeout(() => {
          badgeContainer.classList.remove('guaranteed-fit-badge--selected');
        }, 1000);
      } else {
        // 重置为默认文本
        const defaultSubtext = badgeWrapper.dataset.defaultSubtext || 'EXACT VEHICLE';
        subtext.textContent = defaultSubtext;
        
        // 恢复默认状态
        enhanceBadgeWithVisualFeedback(badgeWrapper, false);
      }
    }
  });
}

/**
 * 增强徽章的视觉反馈
 * @param {HTMLElement} badgeWrapper - 徽章包装元素
 * @param {boolean} isSelected - 是否已选择车辆
 */
function enhanceBadgeWithVisualFeedback(badgeWrapper, isSelected) {
  const badge = badgeWrapper.querySelector('.guaranteed-fit-badge');
  const icon = badgeWrapper.querySelector('.guaranteed-fit-badge__icon');
  
  if (badge) {
    if (isSelected) {
      // 添加选中状态的视觉效果
      badge.classList.add('guaranteed-fit-badge--active');
      
      // 图标动画效果
      if (icon) {
        icon.classList.add('guaranteed-fit-badge__icon--pulse');
        setTimeout(() => {
          icon.classList.remove('guaranteed-fit-badge__icon--pulse');
        }, 1500);
        
        // 给圆形对钩图标添加额外的高亮效果
        const checkIcon = icon.querySelector('.guaranteed-fit-check-icon');
        if (checkIcon) {
          checkIcon.style.backgroundColor = 'rgba(34, 197, 94, 1)'; // 更亮的绿色
          setTimeout(() => {
            checkIcon.style.backgroundColor = ''; // 恢复原始颜色
          }, 1000);
        }
      }
    } else {
      // 恢复默认状态
      badge.classList.remove('guaranteed-fit-badge--active');
    }
  }
}

/**
 * 尝试扩展YMM选择器的功能
 */
function extendYMMSelector() {
  // 如果updateModelOptions函数已存在，则尝试扩展它
  if (typeof updateModelOptions === 'function') {
    const originalUpdateModelOptions = updateModelOptions;
    
    // 重写函数以在模型选择后更新徽章
    window.updateModelOptions = function(year, make) {
      // 调用原始函数
      const result = originalUpdateModelOptions.apply(this, arguments);
      
      // 添加延迟以确保模型选择器已更新
      setTimeout(() => {
        updateGuaranteedFitBadges();
      }, 100);
      
      return result;
    };
  }
}

/**
 * 响应式适配
 */
function handleResponsiveBehavior() {
  const isMobile = window.innerWidth < 768;
  
  document.querySelectorAll('[id^="guaranteed-fit-"].guaranteed-fit-badge-wrapper').forEach(badgeWrapper => {
    if (isMobile) {
      // 移动端优化：调整触摸交互
      badgeWrapper.classList.add('guaranteed-fit-badge-wrapper--mobile');
    } else {
      badgeWrapper.classList.remove('guaranteed-fit-badge-wrapper--mobile');
    }
  });
}

/**
 * 添加CSS样式
 */
function addIntegrationStyles() {
  if (document.getElementById('guaranteed-fit-integration-styles')) {
    return; // 避免重复添加样式
  }
  
  const styleElement = document.createElement('style');
  styleElement.id = 'guaranteed-fit-integration-styles';
  styleElement.textContent = `
    /* 选中状态的徽章样式 */
    .guaranteed-fit-badge--active {
      box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.5);
      transform: scale(1.02);
      transition: all 0.3s ease;
    }
    
    /* 车辆选择后的动画效果 */
    .guaranteed-fit-badge--selected {
      animation: guaranteed-fit-pulse-success 1s ease-in-out;
    }
    
    @keyframes guaranteed-fit-pulse-success {
      0% {
        box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.4);
      }
      70% {
        box-shadow: 0 0 0 8px rgba(34, 197, 94, 0);
      }
      100% {
        box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
      }
    }
    
    /* 图标脉冲效果 */
    /* 圆形对钩图标的脉冲效果 */
    .guaranteed-fit-badge__icon--pulse {
      animation: guaranteed-fit-icon-pulse 1.5s ease-in-out;
    }
    
    .guaranteed-fit-check-icon {
      transition: all 0.3s ease;
    }
    
    @keyframes guaranteed-fit-icon-pulse {
      0%, 100% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.2);
      }
    }
    
    /* 移动端优化 */
    @media (max-width: 767px) {
      .guaranteed-fit-badge-wrapper--mobile {
        touch-action: manipulation;
      }
    }
  `;
  
  document.head.appendChild(styleElement);
}

// 自动初始化
(function() {
  // 添加必要的CSS样式
  addIntegrationStyles();
  
  // 监听窗口大小变化
  window.addEventListener('resize', handleResponsiveBehavior);
  
  // 初始化集成
  initializeGuaranteedFitYMMIntegration();
  
  // 初始响应式处理
  handleResponsiveBehavior();
})();